/* ==========================================================================
   Oh!My Snacks · comportamento do corpo da homepage
   --------------------------------------------------------------------------
   GERADO. Não editar à mão.

   Sai de `oh-my-brand/site/homepage/index.html` pelo
   `alteracoes/homepage/preparar.py`, que faz 8 trocas e mais nenhuma. Para
   mudar seja o que for, muda-se o protótipo e volta-se a correr o preparar.

   O que aqui não está, e porquê: as entradas `.sobe`, o header que assenta e o
   painel de telemóvel vivem no `oms-ohm.js`, porque o header e o rodapé
   existem em todas as páginas e este ficheiro só carrega na homepage.
   ========================================================================== */

(function(){
  var reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Os dados que o Liquid entrega no <script id="ohm-dados">: as 16 categorias
     com nome, link e imagem, e os 40 URL da grelha do exemplo de box. No
     protótipo estavam escritos aqui no código, porque era uma página só; num
     tema com três línguas, três conjuntos de nomes e assets com `?v=`, quem os
     sabe é o Liquid. */
  var dados = {};
  try { dados = JSON.parse(document.getElementById('ohm-dados').textContent); }
  catch (e) { dados = {}; }
  var cats = dados.categorias || [];
  function tile(c){
    return '<a class="cat" href="' + c.url + '"><div class="caixa"><img loading="lazy" src="'
      + c.imagem + '" alt="' + c.nome + '"></div><span>' + c.nome + '</span></a>';
  }
  var metadeA = cats.slice(0,8), metadeB = cats.slice(8);
  var pistaA = document.querySelector('[data-marq="a"]'), pistaB = document.querySelector('[data-marq="b"]');
  /* v3.8 (2026-09-05): os 32 tiles montam-se quando a seccao esta a um ecra de distancia,
     e nao no arranque. O que a pessoa ve e igual; o DOM inicial e mais leve. */
  function montarMarq(){
    if (pistaA && !pistaA.childNodes.length) pistaA.innerHTML = (metadeA.map(tile).join('')).repeat(2);
    if (pistaB && !pistaB.childNodes.length) pistaB.innerHTML = (metadeB.map(tile).join('')).repeat(2);
  }
  var marq = document.querySelector('.marq');
  if (marq && 'IntersectionObserver' in window) {
    var ioM = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) { montarMarq(); ioM.disconnect(); } });
    }, { rootMargin: '100% 0px' });
    ioM.observe(marq);
  } else { montarMarq(); }

  /* As entradas `.sobe` passaram para o oms-ohm.js: o rodapé também as usa e
     o rodapé existe em todas as páginas. O mesmo para o header que assenta e
     para o painel de telemóvel. */

  function lim(v){ return v<0?0:v>1?1:v; }
  function suave(t){ return t*t*(3-2*t); }

  /* v3.5 (2026-09-04): as fotografias das cenas pedem-se quando a cena esta a 300px do
     ecra, e nao antes (80px). O loading="lazy" do browser dispara a 1250px e ja trazia a
     primeira cena (107 KB) no arranque, sem ninguem a ver. */
  (function(){
    var fotos = [].slice.call(document.querySelectorAll('.passo-foto picture'));
    function pedir(p){
      p.querySelectorAll('source[data-srcset]').forEach(function(so){ so.srcset = so.dataset.srcset; so.removeAttribute('data-srcset'); });
      var im = p.querySelector('img[data-src]'); if (im) { im.src = im.dataset.src; im.removeAttribute('data-src'); }
    }
    if ('IntersectionObserver' in window) {
      var ioF = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { pedir(e.target); ioF.unobserve(e.target); } });
      }, { rootMargin: '80px 0px' });
      fotos.forEach(function(p){ ioF.observe(p); });
    } else { fotos.forEach(pedir); }
  })();

  /* os tres passos: a mesma cena lenta em cada um */
  var cenas = [].slice.call(document.querySelectorAll('.passo-cena')).map(function(s){
    var f = (s.dataset.luz || '50% 70%').split(' ');
    var luz = s.querySelector('.passo-luz');
    if (luz) { luz.style.left = f[0]; luz.style.top = f[1]; }
    return { sec:s, foto:s.querySelector('.passo-foto img'), veu:s.querySelector('.passo-veu'),
             luz:luz, copy:s.querySelector('.passo-copy'), sim:s.querySelector('.sim'),
             zoom: parseFloat(s.dataset.zoom || '0.15') };
  });

  function desenhar(){
    if (reduz) return;
    cenas.forEach(function(c){
      var r = c.sec.getBoundingClientRect();
      if (r.bottom < -300 || r.top > window.innerHeight + 300) return;
      /* percurso completo: da entrada do painel ate a secção sair,
         para nao haver ecrã escuro parado antes de a cena prender */
      var p = suave(lim((window.innerHeight - r.top) / r.height));
      c.foto.style.transform = 'scale(' + (1 + c.zoom - p * c.zoom).toFixed(3) + ')';
      c.veu.style.opacity = (0.86 - lim((p - 0.04) / 0.55) * 0.5).toFixed(3);
      c.luz.style.transform = 'translate(-50%,-50%) scale(' + (0.08 + p * 1.04).toFixed(3) + ')';
      c.luz.style.opacity = (p < 0.9 ? 1 : 1 - (p - 0.9) * 5).toFixed(3);
      var k = lim((p - 0.08) / 0.18);
      c.copy.style.opacity = k.toFixed(3);
      c.copy.style.transform = 'translateY(' + (-50 + (1 - k) * 2.4).toFixed(2) + '%)';
      if (c.sim) {
        var q = lim((p - 0.16) / 0.2);
        c.sim.style.opacity = q.toFixed(3);
        c.sim.style.transform = 'translateY(' + (-50 + (1 - q) * 2.4).toFixed(2) + '%)';
      }
    });
  }
  var pend = false;
  addEventListener('scroll', function(){
    if (pend) return; pend = true;
    requestAnimationFrame(function(){ desenhar(); pend = false; });
  }, { passive:true });
  addEventListener('resize', desenhar);
  desenhar();

  /* o sublinhado do "tua" desenha-se à medida que se rola */
  (function(){
    var risco = document.querySelector('.receber h2 .risco');
    if (!risco) return;
    var folha = document.createElement('style');
    document.head.appendChild(folha);
    if (reduz) { folha.textContent = '.ohm-home .receber h2 .risco::after{transform:scaleX(1)}'; return; }
    var ultimo = -1, pend3 = false;
    function desenhar(){
      var r = risco.getBoundingClientRect();
      var vh = window.innerHeight;
      /* desenha enquanto a palavra atravessa a zona de leitura */
      var p = (vh * 0.86 - (r.top + r.height / 2)) / (vh * 0.34);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      var q = Math.round(p * 100);
      if (q === ultimo) return;
      ultimo = q;
      folha.textContent = '.ohm-home .receber h2 .risco::after{transform:scaleX(' + (q / 100) + ')}';
    }
    addEventListener('scroll', function(){
      if (pend3) return; pend3 = true;
      requestAnimationFrame(function(){ desenhar(); pend3 = false; });
    }, { passive:true });
    addEventListener('resize', desenhar);
    desenhar();
  })();

  /* o exemplo de box: cada snack tem outro atrás, e vira uma só vez ao rolar */
  (function(){
    var caixa = document.querySelector('.caixa');
    if (!caixa) return;
    /* v4.2 (2026-09-09): as 40 fotografias da grelha passam a ser as escolhidas pelo Ricardo na
       folha "snacks" (52 candidatas, 40 escolhidas e 12 fora: cinco com a embalagem a vista, quatro
       com fundo escuro, uma cortada na margem, duas de reserva). Locais, em AVIF de 240 px com WebP
       ao lado, cerca de 6 KB cada. **Emparelhadas por DIFERENCA**, nao por semelhanca (correcao do
       fundador, 2026-09-09): a seccao existe para mostrar diversidade, e uma celula que vira de wafer
       para wafer diz "mais do mesmo". Cada celula vira para outra familia, e na grelha 5x4 nenhum
       vizinho, na horizontal ou na vertical, repete familia em nenhum dos dois estados. g00..g19 sao
       as frentes e g20..g39 as costas da mesma celula. O que e cada uma esta em
       exemplo-box/o-que-e-cada-um.json. Antes vinham do CDN da loja e cinco delas so tinham 125 px. */
    /* As 40 fotografias são assets do tema e levam um `?v=` que só o Liquid
       sabe: vêm no <script id="ohm-dados">. São WebP e não AVIF — os assets do
       tema não aceitam AVIF, e a diferença de bytes não se vê a 240px. */
    var grelha = dados.grelha || {};
    var frente = grelha.frente || [], atras = grelha.atras || [];
    if (frente.length !== 20 || atras.length !== 20) return;

    var casas = [].slice.call(caixa.querySelectorAll('.casa')).map(function(c){
      return { el: c, a: null, b: null, virada: false };
    });
    /* v3.5 (2026-09-04): as 40 imagens (frente e verso) so se pedem quando a caixa
       esta a menos de um ecra de distancia. Antes vinham todas no arranque, com o
       verso pre-carregado: cerca de 1,2 MB antes de alguem chegar aqui.
       v3.8 (2026-09-05): os proprios <img> so entram no DOM nesse momento. O HTML
       fica com 20 casas vazias e a pagina arranca com 9 imagens em vez de 81. */
    var pedidas = false;
    function pedir(){
      if (pedidas) return; pedidas = true;
      casas.forEach(function(c, i){
        c.a = document.createElement('img'); c.a.alt = '';
        c.b = document.createElement('img'); c.b.alt = ''; c.b.className = 'atras';
        c.el.appendChild(c.a); c.el.appendChild(c.b);
        c.a.src = frente[i]; c.b.src = atras[i];
      });
    }
    if ('IntersectionObserver' in window) {
      var ioCaixa = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { pedir(); ioCaixa.disconnect(); } });
      }, { rootMargin: '100% 0px' });
      ioCaixa.observe(caixa);
    } else { pedir(); }
    if (reduz) return;

    /* a onda atravessa a grelha na diagonal, e nao linha a linha */
    var COLS = 5;
    var limiar = casas.map(function(_, i){
      var d = Math.floor(i / COLS) + (i % COLS);   /* 0 a 7 */
      return 0.10 + (d / 7) * 0.85;                 /* a onda ocupa quase todo o percurso */
    });

    /* a onda tem cadência própria: mesmo que o scroll dispare as vinte no mesmo
       instante, cada casa espera a sua vez, e a diagonal continua a ler-se */
    function virar(c, i, estado){
      if (!c.a || c.virada === estado) return;
      c.virada = estado;
      clearTimeout(c.relogio);
      var d = Math.floor(i / COLS) + (i % COLS);
      c.relogio = setTimeout(function(){
        if (estado) { c.b.classList.remove('atras'); c.a.classList.add('atras'); }
        else        { c.a.classList.remove('atras'); c.b.classList.add('atras'); }
      }, d * 140);
    }

    var pend2 = false;
    function aoRolar(){
      var r = caixa.getBoundingClientRect();
      if (r.top > window.innerHeight + 200 || r.bottom < -200) return;
      /* a referência é o centro da caixa contra o ecrã: a volta dá-se enquanto
         ela atravessa a zona de leitura, de 82% da altura até 45%. Fora daí,
         ninguém está a olhar para ali. */
      var vh = window.innerHeight;
      var centro = r.top + r.height / 2;
      var inicio = vh * 0.92, fim = vh * 0.30;
      var p = (inicio - centro) / (inicio - fim);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      casas.forEach(function(c, i){ virar(c, i, p >= limiar[i]); });
    }
    addEventListener('scroll', function(){
      if (pend2) return; pend2 = true;
      requestAnimationFrame(function(){ aoRolar(); pend2 = false; });
    }, { passive:true });
    addEventListener('resize', aoRolar);
    aoRolar();
  })();

  /* ---------- passo 3: o voto a dar-se sozinho ---------- */
  (function(){
    var v = document.getElementById('voto');
    if (!v) return;
    var rato   = document.getElementById('voto-rato');
    var manter = document.getElementById('voto-manter');
    var botao  = document.getElementById('voto-bt');
    var caras  = v.querySelectorAll('.vot-cara');
    var boa    = v.querySelector('[data-voto="1"]');
    var relogio = [], aVer = false;

    if (reduz) { boa.classList.add('sel'); manter.classList.add('on'); botao.classList.add('pronto'); return; }

    function daqui(alvo){
      var a = alvo.getBoundingClientRect(), b = v.getBoundingClientRect();
      return { x: a.left - b.left + a.width/2 - 11, y: a.top - b.top + a.height/2 - 11 };
    }
    function mover(alvo){
      var p = daqui(alvo);
      rato.style.opacity = '1';
      rato.style.transform = 'translate(' + p.x.toFixed(0) + 'px,' + p.y.toFixed(0) + 'px)';
    }
    function tocar(fn){
      rato.classList.remove('toca'); void rato.offsetWidth; rato.classList.add('toca');
      if (fn) fn();
    }
    function limpar(){
      caras.forEach(function(c){ c.classList.remove('sel'); });
      manter.classList.remove('on','marcado');
      botao.classList.remove('pronto','premido');
      rato.style.opacity = '0';
    }
    function em(ms, fn){ relogio.push(setTimeout(fn, ms)); }

    /* um voto completo: escolher a cara, fixar o snack, submeter */
    function ciclo(){
      relogio.forEach(clearTimeout); relogio = [];
      limpar();
      em(1500, function(){ mover(boa); });
      em(2650, function(){ tocar(function(){
        boa.classList.add('sel');
        manter.classList.add('on');
        botao.classList.add('pronto');
      }); });
      em(4200, function(){ mover(manter.querySelector('i')); });
      em(5350, function(){ tocar(function(){ manter.classList.add('marcado'); }); });
      em(6800, function(){ mover(botao); });
      em(7950, function(){ tocar(function(){
        botao.classList.add('premido');
        setTimeout(function(){ botao.classList.remove('premido'); }, 320);
      }); });
      em(8600, function(){ rato.style.opacity = '0'; });
      em(12200, function(){ if (aVer) ciclo(); });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting && !aVer) { aVer = true; ciclo(); }
          else if (!e.isIntersecting && aVer) { aVer = false; relogio.forEach(clearTimeout); relogio = []; }
        });
      }, { threshold: 0.25 }).observe(v);
    } else { aVer = true; ciclo(); }
  })();

  /* ---------- passo 1: o quiz a responder-se sozinho ---------- */
  (function(){
    var sim = document.getElementById('sim');
    if (!sim) return;
    var rato = document.getElementById('sim-rato');
    var barra = document.getElementById('sim-barra');
    var botao = document.getElementById('sim-bt');
    var ecras = sim.querySelectorAll('.sim-ecra');
    var relogio = [], aVer = false;

    if (reduz) {
      sim.querySelectorAll('[data-toca="1"],[data-toca="2"]').forEach(function(o){ o.classList.add('sel'); });
      return;
    }

    function daqui(alvo){
      var a = alvo.getBoundingClientRect(), b = sim.getBoundingClientRect();
      return { x: a.left - b.left + a.width/2 - 12, y: a.top - b.top + a.height/2 - 12 };
    }
    function mover(alvo){
      var p = daqui(alvo);
      rato.style.opacity = '1';
      rato.style.transform = 'translate(' + p.x.toFixed(0) + 'px,' + p.y.toFixed(0) + 'px)';
    }
    function tocar(alvo, fn){
      rato.classList.remove('toca');
      void rato.offsetWidth;
      rato.classList.add('toca');
      if (fn) fn();
    }
    function ecra(n){
      ecras.forEach(function(e){ e.classList.toggle('on', e.dataset.ecra === String(n)); });
      barra.style.width = (n * 33.4) + '%';
    }
    function limpar(){
      sim.querySelectorAll('.sim-op').forEach(function(o){ o.classList.remove('sel'); });
      sim.querySelectorAll('.sim-tr i').forEach(function(i){ i.style.left = '0%'; });
      rato.style.opacity = '0';
    }
    function em(ms, fn){ relogio.push(setTimeout(fn, ms)); }

    /* um ciclo completo: tres perguntas, cerca de 21 segundos */
    function ciclo(){
      relogio.forEach(clearTimeout); relogio = [];
      limpar(); ecra(1);

      var a = sim.querySelector('[data-toca="1"]');
      var b = sim.querySelector('[data-toca="2"]');
      var c = sim.querySelector('[data-toca="3"]');

      em(1200, function(){ mover(a); });
      em(2350, function(){ tocar(a, function(){ a.classList.add('sel'); }); });
      em(3200, function(){ mover(b); });
      em(4350, function(){ tocar(b, function(){ b.classList.add('sel'); }); });
      em(5300, function(){ mover(botao); });
      em(6350, function(){ tocar(botao, function(){
        botao.classList.add('premido');
        setTimeout(function(){ botao.classList.remove('premido'); }, 320);
      }); });
      em(6800, function(){ ecra(2); rato.style.opacity = '0'; });

      em(8000, function(){ mover(c); });
      em(9150, function(){ tocar(c, function(){ c.classList.add('sel'); }); });
      em(10100, function(){ mover(botao); });
      em(11150, function(){ tocar(botao, function(){
        botao.classList.add('premido');
        setTimeout(function(){ botao.classList.remove('premido'); }, 320);
      }); });
      em(11600, function(){ ecra(3); rato.style.opacity = '0'; });

      em(12800, function(){ sim.querySelector('[data-cur="1"]').style.left = '100%'; });
      em(13600, function(){ sim.querySelector('[data-cur="2"]').style.left = '66%'; });
      em(14400, function(){ sim.querySelector('[data-cur="3"]').style.left = '33%'; });
      em(16800, function(){ mover(botao); });
      em(17900, function(){ tocar(botao, function(){
        botao.classList.add('premido');
        setTimeout(function(){ botao.classList.remove('premido'); }, 320);
      }); });
      em(19200, function(){ if (aVer) ciclo(); });
    }

    /* só corre quando está à vista */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting && !aVer) { aVer = true; ciclo(); }
          else if (!e.isIntersecting && aVer) { aVer = false; relogio.forEach(clearTimeout); relogio = []; }
        });
      }, { threshold: 0.25 }).observe(sim);
    } else { aVer = true; ciclo(); }
  })();


  /* FAQ: o "+" mostra os grupos restantes no mesmo sitio e desaparece */
  (function(){
    var bt = document.getElementById('faq-toggle'), mais = document.getElementById('faq-mais');
    if (!bt || !mais) return;
    bt.addEventListener('click', function(){
      mais.hidden = false; bt.setAttribute('aria-expanded', 'true'); bt.hidden = true;
      var primeiro = mais.querySelector('summary'); if (primeiro) primeiro.focus({ preventScroll: true });
    });
  })();

  /* v4.1: o video de ajuda das FAQ carrega ao clique, nunca antes. */
  document.addEventListener('click', function(ev){
    var bt = ev.target.closest('.ajuda button'); if (!bt) return;
    var cx = bt.parentElement, fonte = cx.dataset.video, cartaz = cx.querySelector('img');
    var v = document.createElement('video');
    v.src = fonte; v.controls = true; v.playsInline = true; v.muted = true; v.preload = 'auto';
    if (cartaz) { v.poster = cartaz.currentSrc || cartaz.src; cartaz.remove(); }
    bt.remove(); cx.appendChild(v); v.play();
  });
  /* faq: abrir e fechar com altura animada, e um aberto de cada vez */
  document.querySelectorAll('.faq details').forEach(function(d){
    var corpo = d.querySelector('.resposta');
    corpo.style.height = '0px';
    d.querySelector('summary').addEventListener('click', function(ev){
      ev.preventDefault();
      var aberto = d.open;
      document.querySelectorAll('.faq details[open]').forEach(function(o){
        if (o !== d) { o.querySelector('.resposta').style.height = '0px'; o.open = false; }
      });
      if (aberto) { corpo.style.height = '0px'; setTimeout(function(){ d.open = false; }, reduz?0:450); }
      else { d.open = true; corpo.style.height = corpo.scrollHeight + 'px'; }
    });
    corpo.style.transition = reduz ? 'none' : 'height .55s cubic-bezier(.16,.68,.36,1)';
  });
})();

(function(){
  var p=document.getElementById('progB');
  function u(){var h=document.documentElement.scrollHeight-innerHeight;
    p.style.width=(h>0?(scrollY/h*100):0)+'%';}
  addEventListener('scroll',u,{passive:true});addEventListener('resize',u);u();
  /* Os preços ficam onde sempre estiveram, em baixo (decisão do fundador).
     A promoção para junto dos passos foi revertida. */
})();
(function(){
  /* Assumo a opacidade do copy e do cartão nas cenas, em telemóvel.
     Replico a entrada da base (para não perder o fade-in) e acrescento
     a saída durante a largada do painel. */
  var lim=function(x){return x<0?0:(x>1?1:x)};
  var suave=function(x){return x*x*(3-2*x)};
  var cenas=[].slice.call(document.querySelectorAll('.passo-cena'));
  function upd(){
    var VH=innerHeight;
    cenas.forEach(function(s){
      var r=s.getBoundingClientRect(), fx=s.querySelector('.passo-fixo');
      var p=suave(lim((VH-r.top)/r.height));
      var kc=lim((p-0.08)/0.18);                 /* entrada do copy   */
      var ks=lim((p-0.16)/0.20);                 /* entrada do cartão */
      var t=fx?fx.getBoundingClientRect().top:0; /* 0 preso, <0 a largar */
      var sai=t<0?lim(1-(-t)/(VH*0.20)):1;       /* saída na largada  */
      var cp=s.querySelector('.passo-copy'), sm=s.querySelector('.sim');
      if(cp) cp.style.setProperty('--fade',(kc*sai).toFixed(3));
      if(sm) sm.style.setProperty('--fade',(ks*sai).toFixed(3));
    });
  }
  addEventListener('scroll',upd,{passive:true});
  addEventListener('resize',upd);
  upd();
})();

/* O nome escrito na tampa e a rotacao de nomes sairam a 2026-08-29, a pedido do
   fundador: pouco masstige. A fotografia fica parada, a box fala por si. */
